import { IDisplayTableModel } from '../../models/display-table-model'
import { DisplayTableView } from '../../shared/display-table-view'
import { FundCategoryModel } from './models/fund-category-model'
import { FundCategoryOrderDefinition } from './models/fund-category-order-definition'

export class DisplayContentViewGenerator {
  constructor(private readonly fundCategoryModelList: FundCategoryModel[]) {
    const fundCategoryOrderDefinition: FundCategoryOrderDefinition =
      new FundCategoryOrderDefinition()
    this.fundCategoryModelList = this.fundCategoryModelList.sort(
      (objA: FundCategoryModel, objB: FundCategoryModel) => {
        return (
          fundCategoryOrderDefinition.getFundCategoryOrder(objA) -
          fundCategoryOrderDefinition.getFundCategoryOrder(objB)
        )
      },
    )
  }

  public generateView(
    isMultipleSubAssetSelected: boolean,
    selectedCategory: string[],
  ): DisplayTableView {
    const uniqueRecords: any[] = isMultipleSubAssetSelected
      ? this.prepareUniqueFundCollectionForSubAsset(
          this.groupByCategoryLvl3(
            this.fundCategoryModelList,
            selectedCategory,
          ),
        )
      : this.prepareUniqueFundCollection(this.fundCategoryModelList)

    return new DisplayTableView(uniqueRecords)
  }

  private prepareUniqueFundCollection(
    fundCategoryModelList: FundCategoryModel[],
  ): IDisplayTableModel[] {
    const uniqueFundSet: Set<string> = new Set<string>(),
      alphaViewDisplayTableModelAry: IDisplayTableModel[] = []
    fundCategoryModelList.forEach((fundCategoryModel: FundCategoryModel) => {
      fundCategoryModel.fundDtlAry.forEach((fundObj) => {
        if (!uniqueFundSet.has(fundObj.getFundId())) {
          alphaViewDisplayTableModelAry.push(fundObj)
          uniqueFundSet.add(fundObj.getFundId())
        }
      })
    })
    return alphaViewDisplayTableModelAry
  }

  groupByCategoryLvl3(
    fundCategoryModels: FundCategoryModel[],
    selectedCategory: string[],
  ): {
    [key: string]: FundCategoryModel[]
  } {
    const groupedByCategoryLvl3: { [key: string]: FundCategoryModel[] } = {}

    fundCategoryModels.forEach((model) => {
      const categoryLvl3 = model.categoryLvl3Name || 'undefined'
      if (!groupedByCategoryLvl3[categoryLvl3]) {
        groupedByCategoryLvl3[categoryLvl3] = []
      }
      groupedByCategoryLvl3[categoryLvl3].push(...model.fundDtlAry)
    })
    if (selectedCategory.length > 0) {
      selectedCategory.forEach((category) => {
        if (!groupedByCategoryLvl3.hasOwnProperty(category)) {
          groupedByCategoryLvl3[category] = []
        }
      })
    }
    return groupedByCategoryLvl3
  }

  prepareUniqueFundCollectionForSubAsset(data: {
    [key: string]: any[]
  }): any[] {
    const arrays = Object.values(data)
    if (arrays.length === 0) return []
    if (arrays.length === 1) {
      const uniqueFundSet: Set<string> = new Set<string>()
      const alphaViewDisplayTableModelAry: IDisplayTableModel[] = []
      arrays[0].forEach((item) => {
        if (!uniqueFundSet.has(item.getFundId())) {
          alphaViewDisplayTableModelAry.push(item)
          uniqueFundSet.add(item.getFundId())
        }
      })
      return alphaViewDisplayTableModelAry
    }
    return arrays.reduce((commonElements, currentArray) => {
      return commonElements.filter((element) =>
        currentArray.some((item) => item.fundID === element.fundID),
      )
    })
  }
}
